/* Kings Trillion — theme.js
   Uses Shopify's native AJAX Cart API (/cart/add.js, /cart/change.js, /cart.js)
   so the drawer, cart page and checkout all stay in sync with Shopify itself. */

document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var drawerItems = document.querySelector('[data-cart-drawer-items]');
  var drawerSubtotal = document.querySelector('[data-cart-subtotal]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');
  var openTriggers = document.querySelectorAll('[data-cart-open]');
  var closeTriggers = document.querySelectorAll('[data-cart-close]');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openTriggers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart().then(openDrawer);
    });
  });
  closeTriggers.forEach(function (el) { el.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);

  function renderLine(item) {
    var variant = item.variant_title ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '';
    return (
      '<div class="cart-line" data-line-key="' + item.key + '">' +
        '<img src="' + (item.image || '') + '" alt="' + item.product_title + '" loading="lazy">' +
        '<div class="cart-line__info">' +
          '<p class="cart-line__title">' + item.product_title + '</p>' +
          variant +
          '<div class="cart-line__row">' +
            '<div class="cart-line__qty">' +
              '<button type="button" data-qty-decrease>&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-increase>+</button>' +
            '</div>' +
            '<span class="cart-line__price">' + money(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-line__remove" data-line-remove>Remove</button>' +
        '</div>' +
      '</div>'
    );
  }

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      cartCountEls.forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      if (drawerItems) {
        if (cart.items.length === 0) {
          drawerItems.innerHTML = '<p class="cart-drawer__empty">Your bag is empty. The house awaits.</p>';
        } else {
          drawerItems.innerHTML = cart.items.map(renderLine).join('');
        }
      }
      if (drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price);
      return cart;
    });
  }

  // Delegate qty +/- and remove inside drawer
  if (drawerItems) {
    drawerItems.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-line-key');

      if (e.target.matches('[data-qty-increase], [data-qty-decrease], [data-line-remove]')) {
        var qtyEl = line.querySelector('.cart-line__qty span');
        var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10);

        if (e.target.matches('[data-qty-increase]')) qty += 1;
        if (e.target.matches('[data-qty-decrease]')) qty = Math.max(0, qty - 1);
        if (e.target.matches('[data-line-remove]')) qty = 0;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function () { return refreshCart(); });
      }
    });
  }

  // Add-to-cart forms (product page + quick add)
  document.querySelectorAll('[data-atc-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () {
          if (btn) { btn.textContent = 'Added'; }
          openDrawer();
          setTimeout(function () {
            if (btn) { btn.textContent = originalText; btn.disabled = false; }
          }, 1400);
        })
        .catch(function () {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
        });
    });
  });

  refreshCart();

  // ---------- Product gallery thumbnails ----------
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (main && src) main.src = src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  // ---------- Variant swatches -> hidden select ----------
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var select = picker.querySelector('[data-variant-select]');
    var swatches = picker.querySelectorAll('[data-variant-value]');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        if (sw.disabled) return;
        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
        if (select) {
          select.value = sw.getAttribute('data-variant-value');
          select.dispatchEvent(new Event('change'));
        }
      });
    });
  });

  // ---------- Mobile nav ----------
  var navToggle = document.querySelector('[data-nav-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      var isOpen = siteNav.classList.toggle('is-open-mobile');
      navToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  // ---------- Scroll reveal ----------
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }
});
